import React from "react";
import MultiFaceSwapTemplate from "../../components/MultiFaceSwapTemplate";
import { PreweddingFeatures } from "../../components/Features";
import { PreweddingHeroSection } from "../../components/HeroSection";
import { PreweddingFAQ } from "../../components/faqs";
import { PreweddingGuide } from "../../components/sections/FaceSwapGuide";
import { WhoCanUsePrewedding } from "../../components/sections/WhoCanUseSnapToon";
import { PreweddingBenefits } from "../../components/sections/SnapToonBenefits";
import { FavoriteBorder } from "@mui/icons-material";

const PreweddingFaceSwap: React.FC = () => {
  return (
    <MultiFaceSwapTemplate
      initialSwappedImage="https://snaptoon-development.s3.eu-north-1.amazonaws.com/snaptoon_web/pre-wed/pre_wed_4.jpg"
      toastPrefix="Pre-Wedding"
      badgeIcon={<FavoriteBorder sx={{ fontSize: 18, color: "#c084fc" }} />}
      badgeText="Pre-Wedding AI Swap"
      heroHeading="Pre-Wedding AI Face Swap – Create Magical Couple Portraits"
      heroSubheading="Transform Your Romantic Moments with AI Wedding Concepts"
      heroText="Pre-Wedding AI Face Swap is a specialized tool that allows couples to place their faces into stunning pre-wedding photo concepts, romantic shoot themes, and high-fashion wedding attire. Whether you are planning your wedding, experimenting with creative themes, or simply creating romantic couple portraits, SwapToon makes pre-wedding photo swapping effortless, realistic, and magical."
      HeroSectionComponent={PreweddingHeroSection}
      FeaturesComponent={PreweddingFeatures}
      GuideComponent={PreweddingGuide}
      WhoCanUseComponent={WhoCanUsePrewedding}
      BenefitsComponent={PreweddingBenefits}
      FAQComponent={PreweddingFAQ}
    />
  );
};

export default PreweddingFaceSwap;
